<template>
  <q-select v-model="model" :options="options" label="Year" outlined dense></q-select>
</template>

<script>
export default {
  props: {
    value: Number,
    options: Array
  },

  computed: {
    model: {
      get() {
        return this.value
      },

      set(newVal) {
        this.$emit('input', newVal)
      }
    }
  }
}
</script>
